/* eslint-disable max-len */
import axios from "axios";
import { useMemo, useState, useContext, useRef, useEffect } from "react";
import { useScreenClass } from "react-grid-system";
import { useNavigate } from "react-router-dom";
import { PillarType } from "../../types/Roadmap";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import LoadingSpinner from "../../components/LoadingSpinner";
import { CustomDomainBlock, DomainCard, StyledHr } from "../Quest/Domains";
import { getDomainWidth } from "../../hooks/generateMobileUi";
import MuiIcon from "@mui/material/Icon";
import { StyledText, TextSize, TextStatus } from "../../components/Text";
import { RightAlign } from "../../components/UtilsComponents";
import TableComponent, {
  StyledBodyCell,
  StyledHeaderCell,
  StyledTableRow,
} from "../../components/Table";
import { TableBody, TableHead, TableRow } from "@mui/material";
import theme from "../../styles/theme";
import Icon from "../../components/Icon";
import { VersionContext } from "../../context/VersionContext";
interface Column {
  id: "label" | "description" | "icon" | "iconBg";
  label: string;
  minWidth?: number;
  align?: "right";
  format?: (value: number) => string;
}
function ViewPillars() {
  const navigate = useNavigate();
  const screenClass = useScreenClass();
  const [pillars, setPillars] = useState<PillarType>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );
  const isTablet = useMemo(() => ["md"].includes(screenClass), [screenClass]);
  const [columns, setColumns] = useState<Array<Column>>([
    { id: "label", label: "Title", minWidth: 200 },
    {
      id: "description",
      label: "Description",
      minWidth: 150,
    },
    {
      id: "icon",
      label: "Icon",
      minWidth: 150,
    },
    {
      id: "iconBg",
      label: "Color",
      minWidth: 100,
    },
  ]);
  useEffect(() => {
    fetchCompetencies();
  }, []);
  const { version } = useContext(VersionContext);

  const fetchCompetencies = () => {
    setLoading(true);
    axios
      .get(`/pillar?curriculum_version=${version.version_number}`)
      .then((res) => {
        filterData(res.data.pillars);
      })
      .catch(() => {});
  };
  const filterData = (data: any) => {
    const custom: PillarType = [];
    data.forEach((element: any, index: any) => {
      custom.push({
        id: element.id,
        node: index + 1,
        prefix: element.prefix,
        code: element.code,
        label: element.title,
        description: element.description,
        iconBg: element.graphics.iconbg,
        borderColor: element.graphics.bordercolor,
        icon: element.graphics.icon,
        iconShadow: element.graphics.iconshadow,
        children: [],
      });
      if (element.subdomains && element.subdomains.length > 0) {
        element.subdomains.forEach((elementChild: any, indexChild: any) => {
          custom[index].children.push({
            id: elementChild.id,
            node: Number(
              String(data.length) + String(index + 1) + String(indexChild + 1)
            ),
            label: elementChild.title,
            count: "0/7",
            icon: "",
            description: elementChild.description,
          });
        });
      }
    });
    setPillars(custom);
    setLoading(false);
  };
  return (
    <>
      <TableComponent
        navHeight="84px"
        aria-label="sticky table"
        style={{ background: "white" }}
      >
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <StyledHeaderCell
                key={column.id}
                align={column.align}
                backgroundColor={theme.color.lightBlueGray50}
                color={theme.color.lightBlueGray800}
                style={{ minWidth: column.minWidth, padding: "16px" }}
              >
                {column.label}
              </StyledHeaderCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {pillars.map((row: any, index) => {
            return (
              <StyledTableRow
                hover
                role="checkbox"
                tabIndex={-1}
                // onClick={() => {
                //   onSelect(row);
                // }}
                key={index}
              >
                {columns.map((column) => {
                  if (column.id === "icon") {
                    return (
                      <StyledBodyCell key={column.id} align={column.align}>
                        <MuiIcon
                          sx={{
                            color: "white",
                            padding: "6px",
                            background: row.iconBg,
                            boxShadow: row.iconShadow,
                            borderRadius: "100px",
                            fontSize: "18px",
                            verticalAlign: "middle",
                            marginRight: "5px",
                          }}
                        >
                          {row.icon}
                        </MuiIcon>
                        <StyledText textSize={TextSize.small} fontWeight="600">
                          {row.icon}
                        </StyledText>
                      </StyledBodyCell>
                    );
                  }
                  if (column.id === "iconBg") {
                    return (
                      <StyledBodyCell key={column.id} align={column.align}>
                        <StyledText textSize={TextSize.small} fontWeight="600">
                          {row.iconBg}
                        </StyledText>
                      </StyledBodyCell>
                    );
                  }
                  const value = row[column.id];
                  return (
                    <StyledBodyCell key={column.id} align={column.align}>
                      {column.format && typeof value === "number"
                        ? column.format(value)
                        : value}
                    </StyledBodyCell>
                  );
                })}
              </StyledTableRow>
            );
          })}
        </TableBody>
      </TableComponent>
    </>
  );
}
export default ViewPillars;
